import { useContext } from 'react';
import { VenueContext } from './venue.context';

export const useVenue = () => {
  const context = useContext(VenueContext);

  if (context === undefined) {
    throw new Error('useVenue must be used within a VenueProvider');
  }

  return context;
};
